"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logPageHit = exports.isAllowed = void 0;
var _SecureClient = require("../SecureClient");
// eslint-disable-next-line import/prefer-default-export
const isAllowed = (routePath, referer) => {
  const secureClient = new _SecureClient.SecureClient();
  return secureClient.get(`/security/authz/validate-url?referrer=${referer}&matchUrl=${routePath}`);
};

// eslint-disable-next-line import/prefer-default-export
exports.isAllowed = isAllowed;
const logPageHit = () => Promise.resolve({
  logged: true
});
exports.logPageHit = logPageHit;
//# sourceMappingURL=PageSecurity.js.map